import { container } from '@/infrastructure/container';
import { useClientStore } from '@/store/client.store';
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import type { IProduct } from '@/domain/product/IProduct';

// Fetches the product catalogue, filters out products the current
// white-label theme hides. Owns loading / error state so the view
// stays declarative.
function useProducts() {
    const { t } = useI18n();
    const { theme } = storeToRefs(useClientStore());

    const products = ref<IProduct[]>([]);
    const isLoading = ref(true);
    const error = ref<string | undefined>();

    onMounted(async () => {
        try {
            const result = await container.productRepository.getAll(1, 100);
            const hiddenProductNames = theme.value.hiddenProductNames ?? [];
            products.value = result.items.filter((product) => !hiddenProductNames.includes(product.name));
        } catch {
            error.value = t('product_list_error');
        } finally {
            isLoading.value = false;
        }
    });

    return { error, isLoading, products };
}

export { useProducts };
